import { render, staticRenderFns } from "./PurchaseOrder.vue?vue&type=template&id=bdf5f8b0&scoped=true"
import script from "./PurchaseOrder.vue?vue&type=script&lang=js"
export * from "./PurchaseOrder.vue?vue&type=script&lang=js"
import style0 from "./PurchaseOrder.vue?vue&type=style&index=0&id=bdf5f8b0&prod&lang=css"
import style1 from "./PurchaseOrder.vue?vue&type=style&index=1&id=bdf5f8b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdf5f8b0",
  null
  
)

export default component.exports